import { render, staticRenderFns } from "./CasesCard.vue?vue&type=template&id=5f735b52&scoped=true"
import script from "./CasesCard.vue?vue&type=script&lang=js"
export * from "./CasesCard.vue?vue&type=script&lang=js"
import style0 from "./CasesCard.vue?vue&type=style&index=0&id=5f735b52&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f735b52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f735b52')) {
      api.createRecord('5f735b52', component.options)
    } else {
      api.reload('5f735b52', component.options)
    }
    module.hot.accept("./CasesCard.vue?vue&type=template&id=5f735b52&scoped=true", function () {
      api.rerender('5f735b52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/self-select-stock/components/CasesCard.vue"
export default component.exports